export default function ErrorPage() {
	return (
		<p>Error Page</p>
	)
}
